export interface Category {
  id: string;
  name: string;
  slug: string;
  desc: string;
  count: number;
  icon: string;
}

export interface AnimeItem {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  desc: string;
  image: string;
  rating: number;
  episodes: string;
  year: number;
  status: '连载中' | '已完结' | '即将上线';
  tags: string[];
  views: number;
  featured?: boolean;
}

export interface Article {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  summary: string;
  image: string;
  date: string;
  author: string;
  readTime: string;
  views: number;
  tags: string[];
  sections: { heading: string; body: string }[];
  faq: { q: string; a: string }[];
}

export const siteInfo = {
  name: '动漫网',
  slogan: '二次元快乐入口，一站直达动漫世界',
  url: 'https://mangoclick.github.io',
  email: 'contact@dongmanwang.cn',
  phone: '400-888-6666',
  address: '上海市黄浦区二次元大道 1088 号',
  icp: '沪ICP备20268888号',
};

export const categories: Category[] = [
  { id: 'rexue', name: '热血冒险', slug: 'rexue-maoxian', desc: '燃烧热血，踏上冒险之旅', count: 128, icon: 'ri-fire-fill' },
  { id: 'lianai', name: '校园恋爱', slug: 'xiaoyuan-lianai', desc: '青春悸动，甜蜜日常', count: 96, icon: 'ri-heart-3-fill' },
  { id: 'huanxiang', name: '奇幻异界', slug: 'qihuan-yijie', desc: '异世界幻想，脑洞大开', count: 112, icon: 'ri-sparkling-2-fill' },
  { id: 'kehuan', name: '科幻机甲', slug: 'kehuan-jijia', desc: '未来科技，机械浪漫', count: 74, icon: 'ri-robot-2-fill' },
  { id: 'xuanyi', name: '悬疑惊悚', slug: 'xuanyi-jingsong', desc: '烧脑反转，细思极恐', count: 63, icon: 'ri-ghost-fill' },
  { id: 'riyong', name: '治愈日常', slug: 'zhiyu-richang', desc: '温暖治愈，放松心情', count: 88, icon: 'ri-sun-foggy-fill' },
];

export const animeList: AnimeItem[] = [
  {
    id: 'a1', title: '星辰航线', category: 'rexue', categoryName: '热血冒险',
    desc: '少年踏上浩瀚星海，为守护伙伴燃起心中的火焰。每一场战斗都是成长的印记。',
    image: 'https://readdy.ai/api/search-image?query=epic%20anime%20boy%20hero%20with%20fiery%20orange%20hair%20standing%20against%20cosmic%20starfield%20background%2C%20vibrant%20warm%20coral%20and%20magenta%20color%20palette%2C%20clean%20vector%20anime%20illustration%2C%20bold%20flat%20colors%2C%20dynamic%20hero%20pose%2C%20cinematic%20lighting&width=480&height=640&seq=anime-cover-01&orientation=portrait',
    rating: 9.4, episodes: '全 24 话', year: 2025, status: '连载中',
    tags: ['热血', '冒险', '科幻'], views: 128000, featured: true,
  },
  {
    id: 'a2', title: '落樱之时', category: 'lianai', categoryName: '校园恋爱',
    desc: '春日的樱花树下，一场关于暗恋与告白的温柔故事悄然展开。',
    image: 'https://readdy.ai/api/search-image?query=gentle%20anime%20girl%20and%20boy%20under%20cherry%20blossom%20tree%2C%20soft%20pastel%20pink%20and%20warm%20cream%20tones%2C%20clean%20vector%20anime%20illustration%2C%20romantic%20school%20scene%2C%20falling%20petals%2C%20sweet%20atmosphere&width=480&height=640&seq=anime-cover-02&orientation=portrait',
    rating: 9.1, episodes: '全 12 话', year: 2025, status: '已完结',
    tags: ['恋爱', '校园', '日常'], views: 96000, featured: true,
  },
  {
    id: 'a3', title: '异界旅店', category: 'huanxiang', categoryName: '奇幻异界',
    desc: '开在异世界街角的旅店，迎来送往一个个奇妙的客人，也收藏着无数秘密。',
    image: 'https://readdy.ai/api/search-image?query=cozy%20magical%20inn%20in%20fantasy%20world%20with%20warm%20golden%20lanterns%20and%20curious%20creatures%2C%20vibrant%20anime%20illustration%2C%20amber%20and%20coral%20palette%2C%20whimsical%20clean%20vector%20style&width=480&height=640&seq=anime-cover-03&orientation=portrait',
    rating: 8.8, episodes: '全 13 话', year: 2024, status: '已完结',
    tags: ['奇幻', '治愈', '日常'], views: 78000,
  },
  {
    id: 'a4', title: '钢铁之心', category: 'kehuan', categoryName: '科幻机甲',
    desc: '人类最后的堡垒，由一台钢铁机甲与它的驾驶员共同守护。',
    image: 'https://readdy.ai/api/search-image?query=massive%20mecha%20robot%20kneeling%20in%20warm%20sunset%20city%2C%20dramatic%20anime%20sci-fi%20illustration%2C%20orange%20and%20teal%20contrast%2C%20clean%20vector%20style%2C%20mechanical%20detail%2C%20cinematic%20scale&width=480&height=640&seq=anime-cover-04&orientation=portrait',
    rating: 9.0, episodes: '全 24 话', year: 2025, status: '连载中',
    tags: ['科幻', '机甲', '战斗'], views: 112000, featured: true,
  },
  {
    id: 'a5', title: '迷雾小镇', category: 'xuanyi', categoryName: '悬疑惊悚',
    desc: '常年被迷雾笼罩的小镇，每一个居民都藏着一个不为人知的秘密。',
    image: 'https://readdy.ai/api/search-image?query=mysterious%20small%20town%20shrouded%20in%20fog%20at%20dusk%20with%20dim%20lanterns%2C%20eerie%20anime%20illustration%2C%20deep%20maroon%20and%20amber%20tones%2C%20moody%20clean%20vector%20style%2C%20suspenseful%20atmosphere&width=480&height=640&seq=anime-cover-05&orientation=portrait',
    rating: 8.6, episodes: '全 12 话', year: 2024, status: '已完结',
    tags: ['悬疑', '惊悚', '推理'], views: 65000,
  },
  {
    id: 'a6', title: '厨房里的小确幸', category: 'riyong', categoryName: '治愈日常',
    desc: '一道家常菜，一段温暖的记忆。在厨房的烟火气里，治愈每一个疲惫的夜晚。',
    image: 'https://readdy.ai/api/search-image?query=cozy%20kitchen%20scene%20with%20steaming%20bowl%20of%20ramen%20and%20warm%20hometown%20feel%2C%20cute%20anime%20illustration%2C%20cream%20and%20amber%20palette%2C%20wholesome%20slice%20of%20life%2C%20soft%20clean%20vector%20style&width=480&height=640&seq=anime-cover-06&orientation=portrait',
    rating: 9.2, episodes: '全 12 话', year: 2025, status: '连载中',
    tags: ['治愈', '日常', '美食'], views: 89000, featured: true,
  },
  {
    id: 'a7', title: '剑与契约', category: 'huanxiang', categoryName: '奇幻异界',
    desc: '契约之剑苏醒，被选中的少年踏上改写命运史诗的征途。',
    image: 'https://readdy.ai/api/search-image?query=anime%20sword%20warrior%20holding%20glowing%20contract%20blade%20in%20enchanted%20forest%2C%20epic%20fantasy%20illustration%2C%20coral%20and%20gold%20palette%2C%20clean%20vector%20style%2C%20heroic%20composition&width=480&height=640&seq=anime-cover-07&orientation=portrait',
    rating: 8.9, episodes: '全 24 话', year: 2025, status: '连载中',
    tags: ['奇幻', '战斗', '冒险'], views: 101000,
  },
  {
    id: 'a8', title: '告白电波', category: 'lianai', categoryName: '校园恋爱',
    desc: '一封无法送达的情书，一次跨越青春的电波告白。',
    image: 'https://readdy.ai/api/search-image?query=cute%20anime%20students%20with%20love%20letters%20and%20radio%20waves%20in%20sunny%20school%20corridor%2C%20bright%20pastel%20pink%20and%20cream%20illustration%2C%20clean%20vector%20style%2C%20youthful%20energetic&width=480&height=640&seq=anime-cover-08&orientation=portrait',
    rating: 8.5, episodes: '全 10 话', year: 2024, status: '已完结',
    tags: ['恋爱', '校园', '青春'], views: 54000,
  },
  {
    id: 'a9', title: '星环哨站', category: 'kehuan', categoryName: '科幻机甲',
    desc: '坐落于星环之上的哨站，年轻科学家们对抗着来自深空的未知信号。',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20space%20station%20orbiting%20a%20ringed%20planet%2C%20anime%20sci-fi%20illustration%2C%20warm%20golden%20and%20teal%20lighting%2C%20clean%20vector%20style%2C%20vast%20cosmic%20scale&width=480&height=640&seq=anime-cover-09&orientation=portrait',
    rating: 8.7, episodes: '全 13 话', year: 2025, status: '即将上线',
    tags: ['科幻', '太空', '悬疑'], views: 43000,
  },
  {
    id: 'a10', title: '小镇四季', category: 'riyong', categoryName: '治愈日常',
    desc: '春樱夏雨秋枫冬雪，小镇的四季轮转里，藏着最温柔的时光。',
    image: 'https://readdy.ai/api/search-image?query=picturesque%20small%20town%20through%20four%20seasons%20cherry%20blossom%20summer%20rain%20autumn%20maple%20winter%20snow%2C%20warm%20anime%20illustration%2C%20soft%20cream%20and%20amber%20palette%2C%20clean%20vector%20style&width=480&height=640&seq=anime-cover-10&orientation=portrait',
    rating: 9.0, episodes: '全 12 话', year: 2024, status: '已完结',
    tags: ['治愈', '日常', '四季'], views: 72000,
  },
];

export const articles: Article[] = [
  {
    id: 'n1', title: '2026 春季新番前瞻：十部不容错过的热血与治愈佳作',
    category: 'zixun', categoryName: '新番资讯',
    summary: '2026 年春季新番阵容已经公布，热血、治愈、恋爱题材百花齐放。本文为你盘点最值得期待的十部作品。',
    image: 'https://readdy.ai/api/search-image?query=colorful%20grid%20of%20various%20anime%20posters%20for%20new%20spring%20season%20lineup%2C%20vibrant%20coral%20and%20magenta%20banner%20illustration%2C%20clean%20vector%20style%2C%20excited%20energetic&width=1200&height=630&seq=article-img-01&orientation=landscape',
    date: '2026-08-12', author: '漫研社', readTime: '8 分钟', views: 23800,
    tags: ['新番', '前瞻', '推荐'],
    sections: [
      { heading: '热血篇：再度点燃心中的火焰', body: '今年春季的热血番依旧看点十足。既有老牌 IP 的续作回归，也有原创企划大胆亮剑。热血的本质从来不是打斗本身，而是角色在一次次跌倒中重新站起、守护珍视之物的勇气，这正是观众百看不厌的原因。' },
      { heading: '治愈篇：在喧嚣中寻一份宁静', body: '治愈系作品是这一季的温柔担当。无论是小镇日常、厨房烟火，还是旅途中偶然的相遇，它们都试图提醒我们：生活的美好，往往藏在不被注意的细节里。忙碌之余，给自己一点慢下来的时间。' },
      { heading: '恋爱篇：青春的心跳与悸动', body: '校园恋爱新作延续了细腻的笔触，把暗恋、告白、错过与重逢刻画得丝丝入扣。青春的故事或许并不轰轰烈烈，但那份小心翼翼的心意，却能跨越屏幕触动每一个人。' },
      { heading: '如何选择你的本命番？', body: '面对琳琅满目的新番，不妨先从口碑与题材入手。喜欢爽快的选热血，想要放松的选治愈，期待甜度的选恋爱。更重要的是保持开放心态，大胆尝试那些看似陌生却可能成为惊喜的作品。' },
    ],
    faq: [
      { q: '2026 春季新番在哪里可以抢先观看？', a: '登录动漫网官网首页，即可在新番资讯栏目中查看最新上线作品与直达链接，收藏后随时跟进更新进度。' },
      { q: '热血番和治愈番哪个更适合入门？', a: '这取决于个人偏好。热血番节奏明快、情绪燃点高，适合喜欢刺激与成长的观众；治愈番节奏舒缓、温暖治愈，适合寻求放松与陪伴的观众。' },
    ],
  },
  {
    id: 'n2', title: '盘点 2025 年口碑炸裂的十部神作，你看过几部？',
    category: 'zixun', categoryName: '番剧盘点',
    summary: '从画面到剧情、从配乐到人设，2025 年涌现了大量高质量作品。我们精选十部口碑炸裂的神作，帮你快速补番。',
    image: 'https://readdy.ai/api/search-image?query=trophy%20and%20stars%20surrounding%20stack%20of%20glowing%20anime%20books%2C%20celebration%20of%20great%20anime%20of%20the%20year%2C%20warm%20gold%20and%20coral%20banner%20illustration%2C%20clean%20vector%20style&width=1200&height=630&seq=article-img-02&orientation=landscape',
    date: '2026-08-08', author: '番剧观察员', readTime: '6 分钟', views: 31500,
    tags: ['盘点', '神作', '补番'],
    sections: [
      { heading: '年度口碑之王', body: '本年度口碑榜的榜首，以近乎完美的叙事节奏与角色塑造征服了观众。它不仅在剧情上层层递进，更在情感上实现了深刻的共鸣，是那种看完之后会在心中久久回响的作品。' },
      { heading: '画面与配乐的盛宴', body: '优秀的动画是视听的双重享受。多部作品在作画细节与配乐编排上投入巨大，一场酣畅淋漓的战斗配上恰到好处的 BGM，瞬间将情绪推向高潮，令观众大呼过瘾。' },
      { heading: '冷门却惊艳的黑马', body: '除了热门大作，也有不少冷门作品凭借独特的创意杀出重围。它们或许宣发有限，却靠扎实的内容积累了一大批忠实粉丝，成为本年度最令人惊喜的发现。' },
    ],
    faq: [
      { q: '口碑神作通常具备哪些共同点？', a: '优秀的剧本、立体的角色、精良的制作与到位的配乐往往是神作的共性。更重要的是，它们能引发观众的情感共鸣与持续讨论。' },
      { q: '如何高效补番不踩雷？', a: '建议先看评分与口碑，再结合自己的题材偏好筛选。从动漫网番剧盘点栏目出发，参考真实观众的评价，能大幅降低踩雷概率。' },
    ],
  },
  {
    id: 'n3', title: '经典名场面回顾：那些年让我们泪目的高燃瞬间',
    category: 'zixun', categoryName: '经典回顾',
    summary: '有些画面，只要响起配乐就能让人热泪盈眶。让我们一起回顾动漫史上那些刻进 DNA 的高燃名场面。',
    image: 'https://readdy.ai/api/search-image?query=dramatic%20silhouette%20of%20anime%20hero%20with%20bursting%20tears%20of%20joy%20and%20light%2C%20emotional%20iconic%20scene%2C%20warm%20coral%20and%20amber%20banner%20illustration%2C%20clean%20vector%20style&width=1200&height=630&seq=article-img-03&orientation=landscape',
    date: '2026-08-02', author: '情怀编辑部', readTime: '7 分钟', views: 27900,
    tags: ['名场面', '经典', '情怀'],
    sections: [
      { heading: '那些响起的旋律', body: '一段好的 BGM 往往比台词更能击中人心。当熟悉的旋律响起，无数观众会在同一瞬间红了眼眶，那是独属于二次元的浪漫，也是我们共同的青春记忆。' },
      { heading: '并肩作战的感动', body: '友情与羁绊是动漫永恒的主题。看着角色们为了彼此拼尽全力、在最危急的时刻挺身而出，那份热血与感动总会让人不由自主地握紧拳头。' },
      { heading: '跨越多年的重逢', body: '一部作品的完结不意味着故事的终结，多年之后的重逢反而更显珍贵。老粉丝与新观众在相同的画面里收获不同的感动，这就是经典作品的魅力所在。' },
    ],
    faq: [
      { q: '为什么经典名场面总能引起共鸣？', a: '因为它们承载了角色成长的瞬间与观众共同的情感记忆，当画面、配乐与剧情在某一刻完美契合时，就形成了难以磨灭的集体记忆。' },
    ],
  },
  {
    id: 'n4', title: '补番指南：从入门到进阶，值得一看的治愈系神作推荐',
    category: 'zixun', categoryName: '补番指南',
    summary: '想找一个能安安静静看下去的治愈番？这份从入门到进阶的补番清单，一定能抚慰你疲惫的心灵。',
    image: 'https://readdy.ai/api/search-image?query=relaxing%20cup%20of%20tea%20with%20warm%20light%20and%20cute%20anime%20characters%20relaxing%20in%20cozy%20room%2C%20calming%20cream%20and%20amber%20banner%20illustration%2C%20clean%20vector%20style&width=1200&height=630&seq=article-img-04&orientation=landscape',
    date: '2026-07-28', author: '漫研社', readTime: '5 分钟', views: 20100,
    tags: ['治愈', '补番', '推荐'],
    sections: [
      { heading: '入门级：轻松入坑不设门槛', body: '对于刚刚接触治愈系的新人，建议从短小精悍、节奏轻松的作品入手。这类作品通常以日常琐事为切入点，没有复杂的设定，却能让人在会心一笑中感到温暖。' },
      { heading: '进阶型：细腻叙事引人入胜', body: '进阶玩家可以挑战叙事更细腻、情感更饱满的作品。它们往往在温馨的表象下藏着对成长、离别与生活的思考，回味悠长，值得反复品味。' },
      { heading: '深层治愈：直击心灵的温柔', body: '最顶级的治愈，是懂得如何安放你的情绪。这类作品会温柔地拥抱你的疲惫，告诉你不必总是坚强，偶尔停下来喘口气，也是一种勇敢。' },
    ],
    faq: [
      { q: '治愈系动画适合在什么时间看？', a: '任何需要放松的时刻都合适，尤其适合夜晚或周末。搭配一杯热饮，安静地看完一集，能有效缓解一天的疲惫。' },
      { q: '治愈番和日常番有什么区别？', a: '两者有重叠，但治愈番更强调情感上的抚慰与温暖，日常番则侧重描绘平淡却美好的生活点滴。许多治愈番同时属于日常番。' },
    ],
  },
];

export const getCategory = (id: string) => categories.find((c) => c.id === id);
export const getAnime = (id: string) => animeList.find((a) => a.id === id);
export const getArticle = (id: string) => articles.find((n) => n.id === id);
export const getRelated = (id: string, count = 3) => {
  const item = getAnime(id);
  if (!item) return [];
  return animeList.filter((a) => a.id !== id && a.category === item.category).slice(0, count);
};